export const baseUrl = '/api';

export const PDF_ZOOM_LEVELS: (string | number)[] = [
  'auto',
  'page-actual',
  'page-fit',
  'page-width',
  0.1,
  0.13,
  0.17,
  0.22,
  0.28,
  0.36,
  0.46,
  0.59,
  0.77,
  1,
  1.3,
  1.69,
  2.2,
  2.86,
  4,
];
